import "bootstrap/dist/css/bootstrap.min.css";
import 'react-popper-tooltip/dist/styles.css';

import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import store from "./store/storeIndex";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./errorHandling/ErrorPage";

const errorHandler = (error, errorInfo) => {
  // console.log('Logging error: ', error);
  // console.log("Error info: ", errorInfo);
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ErrorBoundary FallbackComponent={ErrorPage} onError={errorHandler} >
          <App />
        </ErrorBoundary>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
